import MuiCheckbox from "@mui/material/Checkbox";

import { styled } from "@mui/material";

export const Checkbox = styled(MuiCheckbox)((props) => ({
  padding: 0,
  marginRight: props.theme.spacing(1),
}));
